import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { BellRing, Send } from "lucide-react";
import { fmtDate } from "@/components/bp/bpLabels";

/** Admin — relances automatiques des contrats / avenants BP non signés (J+7, tous les 7 j, 3 max). */
export const BpContractRemindersCard = ({ onOpenBp }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/bp/contract-reminders").then((r) => setData(r.data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  useEffect(() => { load(); }, []);
  const run = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/admin/bp/contract-reminders/run");
      toast.success(`${r.sent.length} relance(s) envoyée(s) · ${r.waiting} en attente du délai · ${r.max_reached.length} au maximum`, { duration: 7000 });
      await load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const rule = data?.rule || { first_after_days: 7, every_days: 7, max: 3 };
  return (
    <div className="bg-white border border-[#DEE2E6] p-5 space-y-4 lg:col-span-2" data-testid="bp-reminders-card">
      <div className="flex flex-wrap items-center gap-3">
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold inline-flex items-center gap-2"><BellRing className="h-4 w-4 text-[#F59E0B]" />Relances contrat / avenant non signé</div>
        <div className="text-xs text-[#495057]">Automatique chaque matin (09:00) : 1ʳᵉ relance J+{rule.first_after_days} après que le document est signable, puis tous les {rule.every_days} jours, {rule.max} relances maximum ; récapitulatif envoyé à l'équipe PAG.</div>
        <Button size="sm" onClick={run} disabled={busy} className="ml-auto h-8 bg-[#0A0A0A] text-white text-[10px] uppercase" data-testid="bp-reminders-run"><Send className="h-3.5 w-3.5 mr-1" />{busy ? "…" : "Lancer les relances maintenant"}</Button>
      </div>
      {!data ? <div className="text-xs text-[#868E96]">Chargement…</div> : data.items.length === 0 ? <div className="text-xs text-[#059669] font-semibold" data-testid="bp-reminders-empty">Tous les partenaires actifs ont signé leur contrat et leurs avenants.</div> : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs" data-testid="bp-reminders-table">
            <thead className="bg-[#F8F9FA] text-left text-[10px] uppercase tracking-wider"><tr><th className="p-2">Partenaire</th><th className="p-2">Document</th><th className="p-2">Motif</th><th className="p-2 text-right">Relances</th><th className="p-2">Dernière</th></tr></thead>
            <tbody>
              {data.items.map((r) => (
                <tr key={r.bp_id} className="border-t border-[#F8F9FA]" data-testid={`bp-reminder-row-${r.bp_id}`}>
                  <td className="p-2"><button type="button" onClick={() => onOpenBp?.(r.bp_id)} className="font-mono text-[10px] text-[#002FA7] font-bold hover:underline">{r.bp_code}</button> {r.bp_name}</td>
                  <td className="p-2">{r.kind === "avenant" ? "Avenant" : "Contrat initial"}</td>
                  <td className="p-2 text-[#868E96]">{{ initial: "jamais signé", new_version: "nouvelle version du modèle", grid_changed: "grille modifiée" }[r.reason] || r.reason}</td>
                  <td className="p-2 text-right font-bold" data-testid={`bp-reminder-count-${r.bp_id}`}>{r.reminders_sent}/{r.max}{r.reminders_sent >= r.max && <span className="ml-1 text-[#E60000]">sans réponse</span>}</td>
                  <td className="p-2">{r.last_reminder_at ? fmtDate(r.last_reminder_at) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
